
import { RevCardCarousel } from '@ds/components/CardCarousel'
import isEmpty from 'lodash/isEmpty'

import BuyingGuideCard from '@buying-guide/components/Card'

import translations from './Guides.translations'

export default {
  components: {
    RevCardCarousel,
    BuyingGuideCard,
  },
  props: {
    guides: { type: Array, required: true },
  },
  computed: {
    hasGuides() {
      return !isEmpty(this.guides)
    },
    translations: () => translations,
  },
}
